import { Tabs as InnerTabs, TabsPanel, useTabs } from './tabs';
const Tabs = InnerTabs;
Tabs.Panel = TabsPanel;
Tabs.useTabs = useTabs;
export default Tabs;
